import React, {Component} from 'react';
import styled from 'styled-components'
import {GatsbyImage} from "gatsby-plugin-image";
import {media} from "utils/Media"
import Plx from 'react-plx';

const parallaxData = [
    {
        start: 0,
        duration: 1000,
        properties: [
            {
                startValue: 150,
                endValue: 0,
                property: "translateY"
            },
        ],
    },
];

const Wrapper = styled.div`
    margin: 44px auto 0;
    width: 100%;
    text-align: center;
    position: relative;
    
    h1 {
        position: absolute;
        bottom: 70px;
        left: 0;
        color: ${props => props.theme.colors.white};
        font-family: ${props => props.theme.font.family.futuraBold};
        font-weight: bold;
        text-transform: uppercase;
        text-shadow: 0px 0px 12px rgba(0, 0, 0, 0.65);
        text-align: center;
        width: 100%;
        margin-bottom: 1rem;
        font-size: 2.5rem;
        line-height: 2.5rem;
        
        @media ${media.sm} {
            bottom: 0;
        }
        
        @media ${media.md} {
            margin-bottom: 2rem;
            font-size: 4.375rem;
            line-height: 3.75rem;
        }
    }
`

const ParallaxStyled = styled.div`
    position: relative;
    overflow: hidden;
    
    .MyAwesomeParallax {
        margin-top: -200px;
        overflow: hidden;
    }
`;

class ParallaxImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disabled: false,
            imagesAreLoaded: false
        }
    }

    componentDidMount() {
        window.addEventListener('load', this.handleResize, true);
        window.addEventListener('resize', this.handleResize, true);
    }

    componentWillUnmount() {
        window.removeEventListener('load', this.handleResize, true);
        window.removeEventListener('resize', this.handleResize, true);
    }

    handleResize = () => {
        const width = window.innerWidth;

        if (width < 1200) {
            this.setState({
                disabled: true
            });
        } else {
            this.setState({
                disabled: false
            });
        }
    }

    render() {
        return (
            <Wrapper>
                <GatsbyImage image={this.props.data.imageXs.childImageSharp.gatsbyImageData}
                    alt=""
                    title=""
                    className="image d-block d-sm-none"
                    onLoad={() => this.props.imagesAreLoaded('xs')}
                />
                <GatsbyImage image={this.props.data.imageSm.childImageSharp.gatsbyImageData}
                    alt=""
                    title=""
                    className="image d-none d-sm-block d-lg-none"
                    onLoad={() => this.props.imagesAreLoaded('sm')}
                />
                <GatsbyImage image={this.props.data.imageLg.childImageSharp.gatsbyImageData}
                    alt=""
                    title=""
                    className="image d-none d-lg-block d-xl-none"
                    onLoad={() => this.props.imagesAreLoaded('lg')}
                />
                <ParallaxStyled>
                    <Plx
                        className='MyAwesomeParallax'
                        parallaxData={parallaxData}
                        disabled={this.state.disabled}
                    >
                        <GatsbyImage image={this.props.data.image.childImageSharp.gatsbyImageData}
                            alt=""
                            title=""
                            className="image d-none d-xl-block"
                            onLoad={() => this.props.imagesAreLoaded('xl')}
                        />
                    </Plx>
                </ParallaxStyled>
                <h1 dangerouslySetInnerHTML={{__html: this.props.title}}/>
            </Wrapper>
        );
    }
}

export default ParallaxImage